
import { View } from 'backbone';
import template from 'common-views/inputs-by-stage-and-role.ejs';
import template_details from 'common-views/stage-and-role-details.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import _ from 'lodash';
import listService from 'ListService.js';
import settingsService from 'MandatoryAndStateSettingsService.js';
import util from "util/Util";
import eventBus    from 'EventBus';
import {OrderedMap} from "immutable";

class InputsByStageAndRole extends View {

    initialize(opts) {
        $('body').append(this.$el);

        this.validateOptions(opts);

        this.options = opts.options;
        this.title = opts.title;
        this.emptyTitle = opts.emptyTitle || '';
        this.settings = opts.settings;
        this.settingsValue = opts.settingsValue;
        this.defaultValue = opts.defaultValue;
        this.stage = opts.stage;
        this.mandatory = 'all';
        this.role = opts.role;
        this.inputs = [];
        this.$table;

        this.model.set('actionSectionTitle', this.settings === 'mandatories' ? 'Mandatory' : 'State');
        const groups = ['control_group', 'control_radio_button_group', 'control_checkbox_group'];

        listService.getFilteredControls(opts.filter).forEach((input) => {
            let pageName = this.getPageName(input.model.get('pageId'));

            if (this.title === "Mandatory Objects Overview") {
                if(input.model.get('factoryKey') === 'control_table'){
                    input.model.get('gridData').forEach((cell)=>{
                        this.inputs.push({
                            id: `${input.model.get('id')}-${cell.get('id')}`,
                            state: !cell.get('mandatories') || cell.get('mandatories').size === 0 ? 'no' : this.getControlSettings(cell, this.stage, this.role),
                            name: `${pageName} - ${input.model.get('name')} - ${cell.get('name')}`
                        });
                    });
                }
                else {
                    let isGroup = groups.indexOf(input.model.get('factoryKey')) !== -1;
                    let isYes = util.isTrue(this.getControlSettings(input, this.stage, this.role));

                    if(!isGroup){
                        this.inputs.push({
                            id: input.model.get('id'),
                            state: isYes ? 'yes':'no',
                            name: pageName + ' - ' + input.model.get('name')
                        });
                    }
                }
            } else {
                if(input.model.get('factoryKey') === 'control_table'){
                        input.model.get('gridData').forEach((cell)=>{
                            this.inputs.push({
                                id: `${input.model.get('id')}-${cell.get('id')}`,
                                state: this.getControlSettings(cell, this.stage, this.role),
                                name: `${pageName} - ${input.model.get('name')} - ${cell.get('name')}`
                            });
                        });
                }
                if(input.state || input.model.get('state')) {
                    this.inputs.push({
                        id: input.model.get('id'),
                        state: this.getControlSettings(input, this.stage, this.role),
                        name: pageName + ' - ' + input.model.get('name')
                    });
                }
            }
        });

        this.model.set('stages', listService.getWorkflowStages(true, true).map(item=>{ return {id:item.model.get('id'), name:item.model.get('name')} }));
        this.model.set('roles', listService.getWorkflowRoles(true, true));
    }

    getPageName(pageId) {
        let page = listService.getPage(pageId);
        let pageName = '';
        if (page) {
            pageName = page.model.get('name');
        }

        return pageName;
    }

    validateOptions(opts) {

        const isArray = function (field) {
                return Array.isArray(field);
            },
            isDefined = function (field) {
                return field !== undefined;
            },
            isNotEmptyString = function (field) {
                return typeof field === 'string' && field !== '';
            },
            isFunction = function (field) {
                return typeof field === 'function'
            },
            mandatoryOptions = {
                'options': {
                    verify: isArray
                },
                'settings': {
                    verify: isNotEmptyString
                },
                'settingsValue': {
                    verify: isNotEmptyString
                },
                'defaultValue': {
                    verify: isDefined
                },
                'stage': {
                    verify: isNotEmptyString
                },
                'role': {
                    verify: isNotEmptyString
                },
                'filter': {
                    verify: isFunction
                }
            };

        Object.keys(mandatoryOptions).forEach(function (setting) {
            const verify = mandatoryOptions[setting].verify;
            if (!verify(opts[setting])) {
                throw 'Missing ' + setting + ' or wrong value set';
            }
        })


    }


    getCurrentKey() {
        return this.stage + '_' + this.role;
    }

    getCurrentRoleName() {
        let roleName = 'All';
        const role = listService.getWorkflowRole(this.role);
        if (role) {
            roleName = role.name;
        }
        return roleName;
    }

    getCurrentStageName() {
        let stageName = 'All';
        const stage = listService.getWorkflowStage(this.stage);
        if (stage) {
            stageName = stage.model.get('name');
        }
        return stageName;
    }


    getViewValues() {
        return _.merge(this.model.toJSON(), {
            stageName: this.getCurrentStageName(),
            roleName: this.getCurrentRoleName(),
            options: this.options,
            inputs: this.inputs,
            showInputTable:true,
            title: this.title,
            emptyTitle: this.emptyTitle
        });
    }

    getAllInputs() {
        return $('select.setting');
    }

    saveData() {
        const inputs = this.getAllInputs();
        inputs.map((index, input) => {
            const objectId = input.getAttribute('data-object-id');
            let tableColumnIds=objectId.split('-');
            let settings,object;
            if(objectId.includes('-')){
                let tableObject=listService.getObject(tableColumnIds[0]);
                object=tableObject.model.get('gridData').filter(elem=>{
                    return elem.get('id') === tableColumnIds[1]
                })[0];
                if(!object.get(this.settings)){
                    object.set(this.settings,new Map());
                }
                settings=object.get(this.settings)
            }
            else{
                object = listService.getObject(objectId);
                if(!object){
                    object.set(this.settings,new Map());//
                }
                settings = object.model.get(this.settings);
            }
            
            if (input.value !== this.getControlSettings(object, this.stage, this.role)) {
                const newSetting = settingsService.createSetting(this.stage, this.role, this.settingsValue, input.value);
                settings.set(this.getCurrentKey(), newSetting);
                if (this.getCurrentKey() === constants.STRING_MATRIX_FULL_ENTRY){
                  settings.forEach( setting => {
                  setting.value = input.value; 
               });
           }
                if(objectId.includes('-')) {
                    listService.getObject(tableColumnIds[0]).model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                }
                else{
                    listService.getObject(objectId).model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                }
            }

        });
    }

    getControlSettings(control, stageId, roleId) {
        const
            options = {
                stageId: stageId,
                roleId: roleId,
                settings: this.getControlSettingsMap(control),
                defaultValue: this.defaultValue,
                settingsField: this.settingsValue
            };

        return settingsService.getSetting(options);
    }
    getControlSettingsMap(control) {
        if(control.model) {
            return control.model.get(this.settings);
        }
            return control.get(this.settings);
    }

    render() {
        this.$el.html(template(this.getViewValues()));

        listService.isUndoRedoEnabled = false;

        $(constants.DIALOG_ID).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: "auto",
            maxHeight: 500,
            width: 600,
            modal: true,
            resizable: true,
            resize: (event, ui)=>{
                $(event.target).css('width', '100%').css('height', '80%');
            },
            buttons: [
                {
                    text: 'OK',
                    'class': 'btn-std-width btn-default hvr-glow',
                    click: () => {
                        this.saveData();
                        this.closeModal();
                    }
                },
                {
                    'text': 'Cancel',
                    class: 'btn-std-width btn-default hvr-glow',
                    click: () => {
                        this.closeModal();
                    }
                },
                {
                    'text': 'Reset',
                    class: 'btn-std-width btn-default hvr-glow',
                    click: () => {
                        this.turnAllDefault();
                    }
                }
            ],
            open: () => {
                this.bindEvents();
                $(constants.DIALOG_ID).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                if(this.role){
                    $(constants.DIALOG_ID).find(`#roleChoice option[value=${this.role}]`).prop('selected',true);
                }
                if(this.mandatory){
                    $(constants.DIALOG_ID).find(`#mandatoryChoice option[value=${this.mandatory}]`).prop('selected',true);
                }
                if(this.stage){
                    $(constants.DIALOG_ID).find(`#stageChoice option[value=${this.stage}]`).prop('selected',true);
                }
            },
            close: () => {
                this.unbindEvents();
            }
        });

        $('div[role="dialog"]').draggable({ containment: 'body', scroll: false });

        $('.data-switch').on('change', (evt)=>{
            switch(evt.target.id) {
                case 'roleChoice':
                    this.model.set('options', {id:'id', value:'no', label:'role'}, constants.MODEL_SILENT);
                    this.role = evt.target.value;
                    this.filterState();
                    break;
                case 'mandatoryChoice':
                    this.model.set('options', {id:'id', value:'yes', label:'mandatory'}, constants.MODEL_SILENT);
                    this.mandatory = evt.target.value;
                    this.model.set('isMandatory',true,{silent:true});
                    this.filterState(evt.target.value);
                    $(constants.DIALOG_ID).find('#stage-and-roles-table tbody tr td').remove();
                    if(this.inputs.length > 0) {
                        _.each(this.inputs, (elem) => {
                            let nodeToAppend = `
                                <tr>
                                     <td>
                                        <span class="content">
                                            ${elem.name}
                                        </span>
                                    </td>
                                    <td class="fit">
                                        <select class="setting btn-std-width" data-object-id="${elem.id}">
                                            
                                            <option value="yes" ${elem.state === 'yes' ? 'selected' : ''}">Yes</option>
                                            
                                            <option value="no" ${elem.state === 'no' ? 'selected' : ''}>No</option>
                                            
                                        </select>
                                    </td>
                                 </tr>
                                `;
                            $(constants.DIALOG_ID).find('#stage-and-roles-table tbody').append(nodeToAppend)
                        })
                    }
                    break;
                case 'stageChoice':
                    this.model.set('options', {id:'id', value:'no', label:'stage'}, constants.MODEL_SILENT);
                    this.stage = evt.target.value;
                    this.filterState();
                    break;
                default:
                    break;
            }
        });
    }

    triggerUpdate( ) {
        this.model.trigger(constants.EV_ISMANDATORY_ROLE_OR_STAGE_UPDATED);
    }

    filterState(mandatoryInputFilter){
        let pageId;
        let filteredStates = listService.getFilteredControls(this.filterFunc.bind(this));
        let tables= listService.getFilteredControls((elem)=>{
            return elem.model.get('factoryKey') === 'control_table'
        });
        if(tables.size > 0){
            let self=this;
            pageId=tables.first().model.get('pageId');
            tables.forEach((table)=>{
                let filteredTables = table.model.get('gridData').filter(this.filterFunc.bind(self));
                filteredTables.forEach(column=>{
                    column.set('columnTableId',`${table.model.get('id')}-${column.get('id')}`);
                    filteredStates = filteredStates.set(column.get('id'),column);
                })
            });
        }
        this.inputs = [];
        filteredStates.forEach((input)=>{
            let pageName = this.getPageName(input.model ? input.model.get('pageId') :pageId);
            let isYes = util.isTrue(this.getControlSettings(input, this.stage, this.role));
            let state = isYes ? 'yes' : 'no';

            if(mandatoryInputFilter === 'all' || mandatoryInputFilter === state) {
                let inputState = {
                    id: input.model ? input.model.get('id') : input.get('columnTableId'),
                    state: state,
                    name: `${pageName} - ${input.model ? input.model.get('name') : input.get('name')}`
                };
                this.inputs.push(inputState);
                $(constants.DIALOG_ID).find(`[data-object-id=${input.model ? input.model.get('id') : input.get('columnTableId')}] option[value=${inputState.state}]`).prop('selected', true);
            }
            else{
                let inputState = {
                    id: input.model ? input.model.get('id') : input.get('id'),
                    state: this.getControlSettings(input, this.stage, this.role),
                    name: pageName + ' - ' + (input.model ? input.model.get('name') : input.get('name'))
                };

                this.inputs.push(inputState);
                $(constants.DIALOG_ID).find(`[data-object-id=${inputState.id}] option[value=${inputState.state}]`).prop('selected',true);
            }
        });

        this.model.set('stages', listService.getWorkflowStages(true, true).map(item=>{ return {id:item.model.get('id'), name:item.model.get('name')} }));
        this.model.set('roles', listService.getWorkflowRoles(true, true));
    }

    isColumnModel(val){
      return (val.className && val.className() === 'GridColumnModel') && val !== undefined && val.has('state');
    }

    filterFunc(val){
        let controlHasNonDefaultSettings = false;
        // Non mandatories
        if ((val.model !== undefined && val.model.has('state') && !this.model.get('isMandatory') === true) || (this.isColumnModel(val) && !this.model.get('isMandatory') === true)) {
            const controlSettings = {
                stageId: this.stage,
                roleId: this.role,
                settings: val.model ? val.model.get('state') : val.get('state'),
                defaultValue: 'default',
                settingsField: 'value'
            };
            let currentSetting = settingsService.getSetting(controlSettings);
            switch (currentSetting){
                case 'default':
                case 'hidden':
                case 'disabled':
                case 'normal':
                case 'readonly': controlHasNonDefaultSettings = true; break;
                default:controlHasNonDefaultSettings = false; break;
            }
        }
        // Mandatories yes
        else if(val.model !== undefined &&
            val.model.get('mandatories') &&
            val.model.get('mandatories').size > 0 &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'yes'
            &&  val.family === 'common_input' ||
            (this.isColumnModel(val) &&
             this.model.get('isMandatory') === true &&
             this.mandatory === 'yes')) {
            const controlSettings = {
                stageId: this.stage,
                roleId: this.role,
                settings: val.model ? val.model.get('mandatories') : val.get('mandatories'),
                defaultValue: "no",
                settingsField: 'required'
            };
            controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) === "no" || settingsService.getSetting(controlSettings) === "yes";
        }

        // Mandatories no
        else if((val.model !== undefined &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'no' &&
            val.family === 'common_input') ||
            (this.isColumnModel(val) &&
                this.model.get('isMandatory') === true &&
                this.mandatory === 'no')) {
            const controlSettings = {
                stageId: this.stage,
                roleId: this.role,
                settings: val.model ? val.model.get('states') : val.get('states'),
                defaultValue: "no",
                settingsField: 'required'
            };
            controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) === "no" || settingsService.getSetting(controlSettings) === "yes";
        }
        else if((val.model !== undefined &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'no' &&
            !val.model.get('mandatories') &&
            val.family === 'common_input') ||
        (this.isColumnModel(val) &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'no' &&
            !val.get('mandatories') )) {
            const controlSettings = {
                stageId: this.stage,
                roleId: this.role,
                settings: val.model ? val.model.get('states') : val.get('states'),
                defaultValue: "no",
                settingsField: 'required'
            };
            controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) === "no" || settingsService.getSetting(controlSettings) === "yes";
        }
        else if((val.model !== undefined &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'all' &&
            val.family === 'common_input')||
            (this.isColumnModel(val) &&
            this.model.get('isMandatory') === true &&
            this.mandatory === 'all')) {
            const controlSettings = {
                stageId: this.stage,
                roleId: this.role,
                settings: val.model ? val.model.get('states') : val.get('states'),
                defaultValue: "no",
                settingsField: 'required'
            };
            controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) === "no" || settingsService.getSetting(controlSettings) === "yes";
        }
        return controlHasNonDefaultSettings;
    }

    turnAllDefault() {
        const inputs = this.getAllInputs();
        inputs.map((index, input) => {
            input.value = this.defaultValue;
        });
    }
    bindEvents() {
    }
    unbindEvents() {
    }
    closeModal() {
        listService.isUndoRedoEnabled = true;
        $(constants.DIALOG_ID).dialog("destroy");
        this.remove();
    }
}

export default InputsByStageAndRole;
